import { Box, InputAdornment, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux/es/hooks/useDispatch';
import { useState } from 'react';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { useAppSelector } from '../../redux/hooks';
import { LOGIN_ROUTE } from '../../utils/routes';
import {
  resetForgetPasswordState,
  setForgetPasswordEmail,
} from '../../redux/forgetPassword/forgetPasswordSlice';
import { isValidEmail } from '../../utils/userInputUtils';
import StyledTextField from '../Common/StyledTextField';
import StyledButton from '../Common/StyledButton';
import { brandTagKey } from '../../config/constants';

function ForgetPasswordEmail() {
  const [username, setUsername] = useState<string>();
  const loading = useAppSelector((state) => state.forgetPassword.loading);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoBackToLogin = () => {
    dispatch(resetForgetPasswordState());
    const brandTag = localStorage.getItem(brandTagKey);
    navigate(brandTag ? `${LOGIN_ROUTE}/${brandTag}` : LOGIN_ROUTE);
  };

  const handleSendResetCode = () => {
    if (!username) return;

    dispatch(setForgetPasswordEmail(username));
  };

  return (
    <>
      <Typography variant="title2Bold" textAlign="center" color="primary">
        {t('forgetPassword.title')}
      </Typography>
      <Box display="flex" flexDirection="column" gap="24px" width="100%">
        <StyledTextField
          variant="outlined"
          onChange={(e) => setUsername(e.target.value)}
          type="email"
          placeholder={t('auth.emailAddress')}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailRoundedIcon sx={{ color: '#6CA3AC', fontSize: '32px' }} />
              </InputAdornment>
            ),
          }}
        />
        <StyledButton
          fullWidth
          onClick={handleSendResetCode}
          disabled={loading || !username || !isValidEmail(username)}
        >
          {loading ? t('forgetPassword.sendResetCode') : t('forgetPassword.sendResetCode')}
        </StyledButton>
      </Box>

      <Typography
        variant="bodyBold"
        textAlign="center"
        color="#7CAEBE"
        onClick={handleGoBackToLogin}
        sx={{
          cursor: 'pointer',
        }}
      >
        {t('forgetPassword.rememberPassword')}
      </Typography>
    </>
  );
}

export default ForgetPasswordEmail;
